<template>
  <div class="l-row">
    <form-group :label="$t('size.label')">
      <multiselect
        v-model="newItem.from.size"
        :options="from.sizes"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('size.label')" :columns="3">
      <multiselect
        v-model="newItem.to.size"
        :options="to.sizes"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      newItem: {
        from: {
          size: null
        },
        to: {
          size: null
        }
      },
      from: {
        sizes: []
      },
      to: {
        sizes: []
      },
      items: [],
      alreadyExists: false,
      showItem: [],
      loaderSizesEcommerce: true,
      loaderSizesMarketplace: true,
      cloneSizes: null
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getSizes(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(sizes => {
          this.from.sizes = sizes
          this.loaderSizesEcommerce = false
          this.hideItem()
          this.$emit('loading', this.loaderSizesEcommerce || this.loaderSizesMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar os tamanhos da Moovin.', 'Erro'))

      api.netshoes.getSizes()
        .then(sizes => {
          this.to.sizes = sizes
          this.loaderSizesMarketplace = false
          this.$emit('loading', this.loaderSizesEcommerce || this.loaderSizesMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar os tamanhos da Netshoes.', 'Erro'))
    },
    methods: {
      hideItem () {
        if (!this.cloneSizes) {
          this.cloneSizes = cloneDeep(this.from.sizes)
        }

        this.from.sizes = cloneDeep(this.cloneSizes)

        for (let i in this.preset.items) {
          const item = this.preset.items[i]

          const index = this.from.sizes.indexOf(item.from.size)
          if (index !== -1) {
            this.from.sizes.splice(index, 1)
          }
        }
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            size: this.newItem.from.size
          },
          to: {
            size: this.newItem.to.size
          }
        }

        if (item.from.size.toLowerCase() === item.to.size.toLowerCase()) {
          notifier.warning('Você não precisa fazer predefinição de itens iguais.', 'Aviso')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.size === item.from.size &&
            itemPreset.to.size === item.to.size
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'active': this.preset.active,
          'item': this.newItem
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      }
    },
    watch: {
      'preset.items' (value) {
        this.items = value

        this.hideItem()
      },
      'newItem.from.size' () {
        this.emitEnabledAdd()
      },
      'newItem.to.size' () {
        this.emitEnabledAdd()
      }
    },
    components: {
      Panel,
      FormGroup,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// SizeAddItem.vue?758d8db6